module.exports = __webpack_public_path__ + "img/card-FFDACA.fcee6da6.png";